import { ComparedValueEntity } from './events.entity'

export class CommunityPeriodEntity {
  date!: string
  posts!: number
  views!: number
  comments!: number
  upvotes!: number
}

export class CommunityPostItemEntity {
  title!: string
  created_by!: string
  created_at!: string
  views!: ComparedValueEntity
  comments!: ComparedValueEntity
  upvotes!: ComparedValueEntity
}

export class CommunityPostsPageEntity {
  total!: number
  items!: CommunityPostItemEntity[]
}

export class CommunityChannelEntity {
  name!: string
  posts!: ComparedValueEntity
  views!: ComparedValueEntity
  comments!: ComparedValueEntity
  upvotes!: ComparedValueEntity
}

export class CommunityTotalsEntity {
  posts!: ComparedValueEntity
  views!: ComparedValueEntity
  comments!: ComparedValueEntity
  upvotes!: ComparedValueEntity
  periods!: CommunityPeriodEntity[]
}
